var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "ugc-almost-done",
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "ugc-almost-done-title text-center",
      "elementType": "h3",
      "keyTranslation": "ugcInterModalHeader"
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "row",
      "elementType": "div"
    }
  }, [_c('CustomText', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }],
    attrs: {
      "customClass": ['ugc-almost-done-text colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5']
    }
  }, [_c('template', {
    slot: "child"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.ugcInterModalDesc1) + " " + _vm._s(_vm.nextUGCComponentDisplayName) + "\n        " + _vm._s(_vm.translations.ugcInterModalDesc2) + ".\n        "), _c('v-popover', {
    staticClass: "ugc-almost-done-popover",
    attrs: {
      "placement": "top",
      "trigger": "hover click",
      "popoverClass": "ugc-almost-done-v-popover"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "icon-help ugc-help-icon"
    }
  }), _c('template', {
    slot: "popover"
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "ugc-almost-done-popover-content"
    }
  }, [_c('CustomImage', {
    attrs: {
      "src": _vm.placementPopoverImageUrl
    }
  })], 1)], 1)], 2)], 1)], 2), _c('CustomText', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOnRepositionWarning,
      expression: "showOnRepositionWarning"
    }],
    attrs: {
      "customClass": ['ugc-almost-done-text-warning colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
      "keyTranslation": "ugcInterModalWarningText"
    }
  }, [_c('template', {
    slot: "child"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.ugcInterModalWarningText) + " " + _vm._s(_vm.nextUGCComponentDisplayName) + "\n        " + _vm._s(_vm.translations.ugcInterModalWarningText2) + ".\n      ")])], 2)], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "row ugc-almost-done-cta-wrapper",
      "elementType": "div"
    }
  }, [_c('CustomButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSecondaryImage && _vm.activeUGCIndex === 0,
      expression: "!isSecondaryImage && activeUGCIndex === 0"
    }],
    attrs: {
      "customClass": ['secondary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
      "keyTranslation": "ugcInterModalUploadAnother",
      "type": "button"
    },
    on: {
      "click": _vm.onUploadAnotherClick
    }
  }), _c('CustomButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSecondaryImage && _vm.activeUGCIndex === 1,
      expression: "!isSecondaryImage && activeUGCIndex === 1"
    }],
    attrs: {
      "customClass": ['secondary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
      "keyTranslation": "modals.addYourImageGallery.addYourImageGallerySelectAnother",
      "type": "button"
    },
    on: {
      "click": _vm.onSelectAnotherClick
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "row ugc-almost-done-cta-wrapper",
      "elementType": "div"
    }
  }, [_c('CustomButton', {
    attrs: {
      "customClass": ['secondary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
      "keyTranslation": !_vm.showOnRepositionWarning ? 'ugcInterModalSamePhoto' : 'ugcInterModalRepNextComp',
      "type": "button"
    },
    on: {
      "click": _vm.continueSameImage
    }
  })], 1), _c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOnRepositionWarning,
      expression: "!showOnRepositionWarning"
    }],
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "ugc-almost-done-linebreak text-center",
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "ugc-almost-done-linebreak-line",
      "elementType": "span"
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "ugc-almost-done-linebreak-text",
      "elementType": "span",
      "keyTranslation": "ugcInterModalOR"
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "row",
      "elementType": "div"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": ['ugc-almost-done-text colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
      "keyTranslation": "ugcInterModalConfirmText"
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "row ugc-almost-done-cta-wrapper",
      "elementType": "div"
    }
  }, [_c('CustomButton', {
    attrs: {
      "customClass": ['ugc-almost-done-cta-finish primary button colums small-8 small-centered', _vm.enableNewUgcModal ? 'medium-7' : 'medium-5'],
      "keyTranslation": "ugcInterModalFinish",
      "type": "button"
    },
    on: {
      "click": _vm.openConfirmDesign
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }